import request from './index'



// 文章数据埋点-增加阅读量
export function getReport(query) {
  //树数据-获取
  return request({
    url: `/base/track/report`,
    method: 'post',
    data: query,
  })
}
// 获取地址信息
export function getCategory(id) {
  //树数据-获取
  return request({
    url: `/base/regions/${id}/children`,
    method: 'get',
  })
}
export function deleteFile(query) {
  return request({
    url: '/base/file/deleteByCopy',
    method: 'get',
    params: query,
  })
}
// 获取图片
export function getFile(query) {
  return request({
    url: '/base/file/get',
    method: 'get',
    params: query,
  })
}
export function getEnumsList(query) {
  return request({
    url: `/enums/search`,
    method: 'get',
    params: query,
  })
}
export function getMemberLevel(query) {
  return request({
    url: `/base/getList`,
    method: 'get',
    params: query,
  })
}

// 获得当前PC网站的配置
export function getTemplateDetail(query) {
  return request({
    url: `/admin/websiteDesign/getTemplateDetail`,
    method: 'get',
    params: query,
  })
}

// 获得站点配置
export function getSite(query) {
  return request({
    url: `/base/getSite`,
    method: 'get',
    params: query,
  })
}

export function commmonAjax(params) {
  return request({
    url: params.url,
    method: params.method,
    params: params.query,
    data: params.data,
  })
}

// 配置表查询
export function detailSetting(query) {
  return request({
    url: `base/setting/detailSetting`,
    method: 'get',
    params: query,
  })
}

// 网站站点详情
export function fetchSiteInfo(query) {
  return request({
    url: `websiteDesign/getPcDetail`,
    method: 'get',
    params: query,
  })
}
